// Список счетов целиком: API отдаёт не больше 100 за запрос, раньше кабинет брал первые 50 и остальное терял.
// Идём по страницам, пока API говорит has_more (или, на старой версии API, пока страница полная).
const PAGE = 100;
const MAX_PAGES = 50;

export async function fetchAllBills(api, url, params = {}) {
  const all = [];
  for (let page = 0; page < MAX_PAGES; page += 1) {
    const res = await api.get(url, { params: { ...params, limit: PAGE, offset: page * PAGE } });
    const list = Array.isArray(res.data?.bills) ? res.data.bills : (Array.isArray(res.data) ? res.data : (res.data?.results || []));
    all.push(...list);
    const hasMore = typeof res.data?.has_more === 'boolean' ? res.data.has_more : list.length === PAGE;
    if (!hasMore || list.length === 0) break;
  }
  return all;
}
